import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faCalendarDays,
	faTimes,
	faTv,
	faCocktail,
	faShower,
	faWifi,
	faAirConditioner,
	faBed,
	faChevronDown,
	faArrowRightLong,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faHotTubPerson,
	faCoffee,
	faUtensils,
	faWineGlass,
	faStore,
	faBicycle,
	faCroissant,
	faCouch,
	faTree,
	faWater,
	faBath,
	faLink,
	faVault,
	faBuildingColumns,
	faSpa,
	faGolfFlagHole,
	faPersonHiking,
	faPersonSkiing,
	faMusic,
	faMasksTheater,
	faHeat,
	faFanTable,
	faRectangleVertical,
} from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck, faBars, faLocationDot, faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { faStar, faQuoteLeft, faStarHalf, faPlay, faSearch } from '@fortawesome/pro-solid-svg-icons';
import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faTiktok,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faBed,
	faTv,
	faUtensils,
	faWifi,
	faStore,
	faHeat,
	faFanTable,
	faRectangleVertical,
	faWineGlass,
	faCocktail,
	faHotTubPerson,
	faCoffee,
	faAirConditioner,
	faShower,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronUp,
	faChevronDown,
	faLocationDot,
	faCalendarDays,
	faArrowRightLong,
	faQuoteLeft,
	faBars,
	faEnvelope,
	faPhone,
	faTimes,
	faCircleCheck,
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faPlay,
	faSearch,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faTiktok,
	faWhatsapp,
	faYoutube,
	faStar,
	faStarHalf,
	faBicycle,
	faCroissant,
	faCouch,
	faTree,
	faWater,
	faBath,
	faLink,
	faVault,
	faBuildingColumns,
	faSpa,
	faGolfFlagHole,
	faPersonHiking,
	faPersonSkiing,
	faMusic,
	faMasksTheater,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
